import React from 'react';
import Image from '../../../components/AppImage';

const Header = ({ language, onLanguageChange }) => {
  const navItems = {
    de: [
      { label: 'Home', href: '#home' },
      { label: 'Services', href: '#services' },
      { label: 'Preise', href: '#services' },
      { label: 'Öffnungszeiten', href: '#hours' },
      { label: 'Standort', href: '#location' },
      { label: 'Kontakt', href: '#contact' }
    ],
    en: [
      { label: 'Home', href: '#home' },
      { label: 'Services', href: '#services' },
      { label: 'Prices', href: '#services' },
      { label: 'Hours', href: '#hours' },
      { label: 'Location', href: '#location' },
      { label: 'Contact', href: '#contact' }
    ]
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-primary/95 backdrop-blur-sm border-b border-secondary/20 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <Image
              src="/assets/images/e75f4f8f-2e2c-47d5-8be6-070fec062583-1755963588204.jpeg"
              alt="RWAN CUT Logo"
              className="w-10 h-10 rounded-full object-cover"
            />
            <div>
              <h1 className="font-heading font-bold text-xl text-secondary">RWAN CUT</h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems?.[language]?.map((item, index) => (
              <button
                key={index}
                onClick={() => scrollToSection(item?.href)}
                className="font-body text-white hover:text-secondary transition-luxury"
              >
                {item?.label}
              </button>
            ))}
          </nav>

          {/* Language Switch */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center bg-secondary/20 rounded-lg p-1">
              <button
                onClick={() => onLanguageChange('de')}
                className={`px-3 py-1 rounded-md text-sm font-body transition-luxury ${
                  language === 'de' ? 'bg-secondary text-primary' : 'text-white hover:text-secondary'
                }`}
              >
                DE
              </button>
              <button
                onClick={() => onLanguageChange('en')}
                className={`px-3 py-1 rounded-md text-sm font-body transition-luxury ${
                  language === 'en' ? 'bg-secondary text-primary' : 'text-white hover:text-secondary'
                }`}
              >
                EN
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;